import React from 'react';
import '../../styles/hero.css';

import escritorioImg from '../../images/1.jpg';
import logo from '../../images/logo_ergue.png';

const Hero = () => {
  return (
    <section className='hero__section'>
      <div className='container'>
        <div className='hero__wrapper'>
          <div className='hero__content'>
            <div>
              <h2 className='highlight'>Arquitectura Design Serviços</h2>
              {/* <h2>Na ERGUE, não projetamos simplesmente espaços</h2>
                        <h2>Concebemos experiências transformadoras.</h2> */}
            </div>
            <p className='description'>
              A ERGUE é uma empresa angolana, que actua no ramo da arquitectura
              buscando oferecer soluções inovadoras e personalizadas para seus
              clientes. Trabalhamos em projetos residenciais e industriais,
              sempre buscando criar espaços funcionais.
            </p>
            <p className='description'>
              Na ERGUE, não projetamos simplesmente espaços; concebemos
              experiências transformadoras. Somos mais do que arquitectos; somos
              contadores de histórias através de formas, luzes e texturas.
            </p>
            <img src={logo} width='180px' height='180px' alt='logo' />
            {/* <div className="hero__btns">
                        <button className="primary__btn">Contacte-nos</button>
                        <button className="secondary__btn">Saiba mais</button>
                    </div> */}
          </div>

          <div className='hero__img'>
            <img
              src={escritorioImg}
              width='550px'
              height='800px'
              alt='ESCRITÓRIO DE ARQUITECTURA'
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
